import { apiClient } from "./api";

/**
 * Corridor API client — anonymous native-plant map for signed-in users
 * in the same state.
 *
 * Privacy: this client sends the browser's raw lat/lon to /contribute, and
 * the server rounds to a ~5.5km grid BEFORE persisting. Every list response
 * only carries bucketed coords + non-identifying plant metadata.
 */
export const corridor = {
  // POST /corridor/contribute { scan_id, lat, lon } — server buckets before write
  contribute: (scan_id, lat, lon) => apiClient.post("/corridor/contribute", { scan_id, lat, lon }),
  // GET /corridor/eligible → { items: [{scan_id, plant_name, thumb_base64, ...}], count }
  eligible: () => apiClient.get("/corridor/eligible"),
  // POST /corridor/bulk-contribute { contributions: [{scan_id, lat, lon, persist_location}] }
  bulkContribute: (contributions) =>
    apiClient.post("/corridor/bulk-contribute", { contributions }),
  // DELETE — owner-only, silently no-ops for scans the user never contributed
  uncontribute: (scan_id) => apiClient.delete(`/corridor/contribute/${scan_id}`),
  // GET the state corridor. Server scopes to user's state — query param ignored.
  list: () => apiClient.get("/corridor"),
  // GET the scan_ids the current user has contributed
  mine: () => apiClient.get("/corridor/mine"),
};
